export enum NotificationType {
    Success = 1,
    // Failure = 2,
    Warning = 3,
    Error = 4,
    ShortNotification = 5,
}
